import { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";

const useApi = () => {
  const [a1b2c3, d4e5f6] = useState([]),
    [g7h8i9, j0k1l2] = useState([]),
    [m3n4o5, p6q7r8] = useState(false),
    s9t0u1 = {};
  function v2w3x4(y5z6a7) {
    p6q7r8(y5z6a7);
  }
  const b8c9d0 = async (e1f2g3, h4i5j6, k7l8m9, n0o1p2, q3r4s5 = false) => {
    p6q7r8(false);
    d4e5f6((t6u7v8) => [...t6u7v8, `${k7l8m9}__${e1f2g3}`]);
    j0k1l2((w9x0y1) =>
      w9x0y1.filter((z2a3b4) => z2a3b4 !== `${k7l8m9}__${e1f2g3}`)
    );
    try {
      let c5d6e7 = {};
      if (h4i5j6) {
        const f8g9h0 = Cookies.get("CCorbitToken");
        if (!f8g9h0) {
          v2w3x4("No estas logueado. Inicia sesión.");
          console.error("Token no encontrado en localStorage");
        }
        c5d6e7["Authorization"] = `Bearer: ${f8g9h0}`;
        if (q3r4s5) c5d6e7["Content-Type"] = "multipart/form-data";
      }
      const i1j2k3 = {
        method: k7l8m9,
        url: `https://vps-c0e77172.vps.ovh.net/${e1f2g3}`,
        headers: c5d6e7,
      };
      if (n0o1p2) {
        if (q3r4s5) {
          const l4m5n6 = new FormData();
          Object.entries(n0o1p2).forEach(([o7p8q9, r0s1t2]) => {
            try {
              if (typeof r0s1t2 === "object" && r0s1t2 !== null) {
                if (u3v4w5(r0s1t2) || u3v4w5(r0s1t2?.[0])) {
                  if (Array.isArray(r0s1t2)) {
                    for (let x6y7z8 of r0s1t2)
                      if (x6y7z8 !== undefined && x6y7z8 !== null)
                        l4m5n6.append(o7p8q9, x6y7z8);
                  } else if (r0s1t2 !== undefined && r0s1t2 !== null)
                    l4m5n6.append(o7p8q9, r0s1t2);
                } else l4m5n6.append(o7p8q9, JSON.stringify(r0s1t2));
              } else if (r0s1t2 !== undefined && r0s1t2 !== null)
                l4m5n6.append(o7p8q9, r0s1t2);
            } catch (e) {
              if (r0s1t2 !== undefined && r0s1t2 !== null)
                l4m5n6.append(o7p8q9, r0s1t2);
            }
          });
          i1j2k3.data = l4m5n6;
        } else i1j2k3.data = n0o1p2;
      }
      const a9b0c1 = await axios(i1j2k3);
      if (a9b0c1.data.error) {
        v2w3x4(a9b0c1.data.error);
        throw new Error(a9b0c1.data.error);
      }
      d4e5f6((d2e3f4) =>
        d2e3f4.filter((g5h6i7) => g5h6i7 !== `${k7l8m9}__${e1f2g3}`)
      );
      j0k1l2((j8k9l0) => [...j8k9l0, `${k7l8m9}__${e1f2g3}`]);
      return a9b0c1;
    } catch (m1n2o3) {
      d4e5f6((p4q5r6) =>
        p4q5r6.filter((s7t8u9) => s7t8u9 !== `${k7l8m9}__${e1f2g3}`)
      );
      if (m1n2o3.response) {
        if (m1n2o3.response.data.message) {
          if (
            ["INVALID_TOKEN", "MISSING_TOKEN"].includes(
              m1n2o3.response.data.message
            )
          ) {
          }
          v2w3x4(m1n2o3.response.data.message);
          throw new Error(m1n2o3.response.data.message);
        } else {
          v2w3x4(
            "Error interno del servidor, actualiza la página e intente nuevamente."
          );
          throw new Error(
            "Error interno del servidor, actualiza la página e intente nuevamente."
          );
        }
      } else {
        v2w3x4("Error de conexión, actualiza la página e intente nuevamente.");
        throw new Error(
          "Error de conexión, actualiza la página e intente nuevamente."
        );
      }
    }
  };
  return {
    loadApi: b8c9d0,
    loadingApi: a1b2c3,
    errorApi: m3n4o5,
    tokenDataApi: s9t0u1,
    loadedApi: g7h8i9,
  };
};
function u3v4w5(x0y1z2) {
  return x0y1z2 instanceof File;
}
export default useApi;
